module.exports = __webpack_public_path__ + "img/achbar_no.633ed6fb.png";